import script from "./AppSettingOtherList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSettingOtherList.vue?vue&type=script&setup=true&lang=js"

import "./AppSettingOtherList.vue?vue&type=style&index=0&id=38edb3f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38edb3f8"]])

export default __exports__